export interface ProductionListMapperI {
  select: boolean;
  id: string;
  customerName: string;
  orderName: string;
  decoTypeName: string;
  productName: string;
  machineName: string;
  variationName: string;
  statusName: string;
  vendorName: string;
  detailName: string;
  qty: string;
  priorityName: string;
  color: string;
  size: string;
  detailCount: string;
  detailDescription: string;
  hours: string;
  due: string;
  productionRate: string;
  workOrderNo: string;
  action: string;
  decorationGroup: string;
  scheduleDate: string;
}
